"use strict";
"use client";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const gigya_service_1 = require("../services/gigya.service");
const gigyaProvider_1 = require("../providers/gigyaProvider");
const LoadScreenset = (props) => {
    const { gigya, isLoaded } = (0, gigyaProvider_1.useGigya)();
    const { renderGigyaComponent } = (0, gigya_service_1.useGigyaService)({ gigya, isLoaded });
    const containerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (typeof window != undefined) {
            if (isLoaded && containerRef.current) {
                renderGigyaComponent(props);
            }
        }
    }, [isLoaded, renderGigyaComponent]);
    return (react_1.default.createElement("div", { id: props.componentId, ref: containerRef }));
};
exports.default = LoadScreenset;
